import { I04DIMPUISCONS_State } from '@batical/types/src'

const I04DIMPUISCONS: I04DIMPUISCONS_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  rendementProduction_uuid: 'ENER1',
  in_rendementProduction1: 0.98,
  in_consommation: 20000.0,
  dju_uuid: '2F384721-09DE-4B82-8582-FD35735868A8',
  in_consigneT: 22.0,
  in_temperatureBase: 0.0,
  in_nbJourChauffe: 190.0,
  in_tempsReduit: 0.0,
  in_deltaTemperatureAbaissement: 0.0,
  rendementProduction_uuid2: 'ENER2',
  in_rendementProduction2: 1.0,
  res_besoinChauffage: 0.0,
  res_intermittence: 0.0,
  res_deperdition: 0.0,
  mode: 'none',
  calcul_code: 'I04DIMPUISCONS'
}

export default I04DIMPUISCONS
